module.exports = __webpack_public_path__ + "static/media/Country-Info.f3f53be0.png";